import styled from 'styled-components';
import { windowMaxWidth } from '../../components/ui/Layout/breakpoints';

const LoginContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 120px;
  margin-top: 15vh;
  max-width: 600px;
  position: relative;
  width: 90vw;
  z-index: 10;

  @media (height <= 600px) {
    max-width: 500px;
    margin-top: 12vh;
    margin-bottom: 140px;
  }
`;

const LoginWelcomMessage = styled.div`
  color: var(--greyscale-white);
  font-size: var(--font-size-heading-1);
  font-stretch: normal;
  font-style: normal;
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--font-letter-spacing-small);
  line-height: 1.13;
  margin-bottom: 40px;
  text-align: center;

  @media ${windowMaxWidth.mobile} {
    font-size: var(--font-size-heading-2);
    margin-bottom: 20px;
  }

  @media (height <= 600px) {
    font-size: var(--font-size-heading-2);
    margin-bottom: 20px;
  }
`;

const LoginFormBackground = styled.div`
  align-items: flex-start;
  background-color: var(--greyscale-white);
  border-radius: var(--border-radius-small);
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  width: 100%;

  form {
    width: 100%;
  }

  button {
    svg {
      path {
        stroke: none;
      }
    }
  }
`;

const LoginSectionWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  width: 100%;

  @media ${windowMaxWidth.mobile} {
    padding: 20px;
  }
`;

const LoginFormWrapper = styled.div`
  width: 100%;

  .ant-form {
    label,
    .ant-form-item-label {
      color: var(--greyscale-shade);
      margin-left: 13px;
      padding: 0;
      font-size: var(--font-size-small);
      line-height: var(--font-line-height-medium);
    }

    .ant-form-item-required {
      margin-left: 0;
    }

    .item-no-margin {
      margin-bottom: 0;
    }
  }

  @media ${windowMaxWidth.mobile} {
    .ant-form {
      .ant-form-item {
        margin-bottom: 20px;
      }
    }
  }

  @media (height <= 600px) {
    padding: 30px;

    .ant-form {
      .ant-form-item {
        margin-bottom: 18px;
      }
    }
  }
`;

const LoginForgotPasswordWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
  position: relative;
  top: -16px;

  @media ${windowMaxWidth.mobile} {
    margin-right: 0;
    top: -20px;
  }

  @media (height <= 600px) {
    margin-right: 0;
    top: -20px;
  }
`;

const LoginButtonWrapper = styled.div`
  margin-top: 10px;
`;

const LoginDivider = styled.div`
  align-items: center;
  color: var(--greyscale-shade);
  display: flex;
  font-size: var(--font-size-small);
  width: 100%;

  &::before,
  &::after {
    border-top: 1px solid var(--greyscale-dark-white);
    content: '';
    flex: 1;
  }
`;

const LoginDividerText = styled.span`
  margin: 0 12px;
  white-space: nowrap;
`;

const InitialSigninEmailWrapper = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-regular);
  margin-bottom: 20px;

  @media (${windowMaxWidth.mobile}) {
    padding: 0;
    margin-left: 0;
  }
`;

const InitialSigninEmailLabel = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-small);
  line-height: var(--font-line-height-small);
  margin-bottom: 4px;

  @media (${windowMaxWidth.mobile}) {
    padding: 0;
    margin-left: 0;
  }
`;

const FormDescriptionTextWrapper = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-regular);
  line-height: var(--font-line-height-regular);
  margin-bottom: 40px;
  text-align: justify;

  @media (${windowMaxWidth.mobile}) {
    padding: 40px 0 0;
  }
`;

const UserAgreementMessageWrapper = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-small);
  line-height: var(--font-line-height-small);
  margin-bottom: 10px;

  a {
    color: var(--primary-oqio-blue);

    :hover {
      color: var(--primary-oqio-blue);
    }
  }

  @media (${windowMaxWidth.mobile}) {
    padding: 20px 00 0;
  }
`;

const SubmitButtonWrapper = styled.div`
  width: 100%;

  @media (${windowMaxWidth.mobile}) {
    padding: 20px 0 40px;
  }
`;

export {
  LoginContentWrapper,
  LoginSectionWrapper,
  LoginWelcomMessage,
  LoginFormBackground,
  LoginFormWrapper,
  LoginForgotPasswordWrapper,
  LoginButtonWrapper,
  LoginDivider,
  LoginDividerText,
  InitialSigninEmailWrapper,
  InitialSigninEmailLabel,
  FormDescriptionTextWrapper,
  UserAgreementMessageWrapper,
  SubmitButtonWrapper
};
